<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>En 1667 se instituye el 12 de diciembre como Jubileo plenísimo a la Virgen de Guadalupe</h2>
    <model-fbx 
      src="galerias/guadalupe/g4m/basilica.fbx"
      :rotation="rotation"
      :backgroundAlpha="0"
      :lights="lights"
      @on-load="onLoad"
      @on-mousemove="onMouseMove"
    >
    </model-fbx>
    <!-- <img @click="imageClicked(0)" src="galerias/guadalupe/g4m/MAQUETA2_B.jpg" class="mainphoto"/> -->
    <p class="photo-description"></p>
    <p>La Nueva Basílica, la “Insigne y Nacional Basílica de Santa María de Guadalupe” se inauguró el 12 de octubre de 1976. Es un edificio emblemático de la arquitectura Mexicana.</p>
    <p>Diseñada principalmente por los arquitectos Fray Gabriel Chávez y Pedro Ramírez, su simbolismo arquitectónico continúa con fuerza acogiendo a millones de peregrinos en esta nueva “casita sagrada”.</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="https://virgendeguadalupe.org.mx/como-llegar/">virgendeguadalupe.org.mx</a></li>
        <li><a target="_blank" href="http://www.revistas.unam.mx/index.php/bitacora/article/viewFile/25174/23668">www.revistas.unam.mx</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
import { ModelFbx } from "vue-3d-model";

export default {
  name: "Sala2m4s1",
  data() {
    return {
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
      lights: [
        {
          type: "HemisphereLight",
          position: { x: 0, y: 20, z: 0 },
          skyColor: 0xffffff, // 0xaaaaff,
          groundColor: 0xffffff, // 0x806060,
          intensity: 0.5,
        },
        {
          type: "DirectionalLight",
          position: { x: 0, y: 20, z: 20 },
          color: 0xffffff,
          intensity: 0.4,
        },
      ],
    };
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
    onLoad() {
      this.rotate();
    },
    rotate() {
      this.rotation.y += 0.001;
      requestAnimationFrame(this.rotate);
    },
    // eslint-disable-next-line no-unused-vars
    onMouseMove(event) {
      // console.log( event ); // event: { distance, face, faceIndex, point, index, uv, object }
    },
  },
  components: { ModelFbx },
  props: {},
  mounted() {},
};
</script>
